import { DeviceModel, ReportModel } from '@/store/types';

export const rangedLatestStatus = (device: DeviceModel, time: Date): string => {
  const now = new Date();
  if (now < time) {
    return '';
  }

  if (device === undefined || device.reports === undefined || device.reports.length < 1) {
    return 'dead';
  }

  const timeEnd = new Date(time.getTime());
  timeEnd.setHours(timeEnd.getHours() + 1);
  timeEnd.setMinutes(0);
  timeEnd.setMilliseconds(0);
  const unixSec = Math.floor(timeEnd.getTime() / 1000);

  const reportsBeforeTime = device.reports.filter(
    (report) => report.deviceId === device.deviceId && report.createdAt < unixSec,
  );
  if (reportsBeforeTime.length < 1) {
    return 'dead';
  }

  const latestStatus = reportsBeforeTime.sort(
    (a: ReportModel, b: ReportModel) => b.createdAt - a.createdAt, /* 時間について降順ソート */
  )[0].status;

  return latestStatus;
};

export const dayStr = (date: Date): string => `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;

export const displayingTimeSpan = (date: Date): Date[] => {
  let result = [] as Date[];
  for (let i = 0; i < 24; ++i) {
    let d = new Date(date.getTime());
    d.setHours(i);
    result.push(d);
  }
  return result;
};
